import type { BorderColorModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { useOptimisticModifierValue } from "@v2/features/modifiers/hooks/useOptimisticModifierValue";
import { useOverridableState } from "replo-runtime/shared/hooks/useOverridableState";

import ColorSelector from "./ColorSelector";

interface BorderColorModifierProps {
  onChange: (modifier: BorderColorModifierValue) => void;
}

const BorderColorModifier: React.FC<BorderColorModifierProps> = ({
  onChange,
}) => {
  const borderColor =
    useOptimisticModifierValue({
      modifierType: { type: "borderColor", value: null },
      extractor: (elementDesignation) => {
        return (
          elementDesignation.element.styleOverrides?.borderBottomColor ??
          elementDesignation.element.styleOverrides?.borderTopColor ??
          elementDesignation.element.styleOverrides?.borderRightColor ??
          elementDesignation.element.styleOverrides?.borderLeftColor ??
          null
        );
      },
    }) ?? null;
  const [currentColor, setCurrentColor] = useOverridableState(
    borderColor,
    React.useCallback(
      (color: string | null) => {
        onChange({
          type: "borderColor",
          value: color,
        });
      },
      [onChange],
    ),
  );

  return <ColorSelector value={currentColor} onChange={setCurrentColor} />;
};

export default BorderColorModifier;
